import type { NavigationGroup } from '@susu/headless-commerce/features/navigation/domain'
import styles from './NavSeparator.module.scss'

export type NavSeparatorProps = {
  group: NavigationGroup
}

export const NavSeparator = ({ group }: NavSeparatorProps) => {
  if (group.hasTopDivider === true) {
    return (
      <span className={styles['nav__separator']} data-testid="nav-separator" />
    )
  }

  return null
}
